import { Observer } from 'mobx-react-lite';
import React from 'react';
import { Primary } from '../../constants/color.enum';
import joinClassName from '../../utils/className.utils';
import { getContextColorStyle } from '../../utils/colors.utils';
import { renderRenderable } from '../../utils/components.utils';
import BaseIcon from '../BaseIcon/BaseIcon';
import './InfoBanner.scss';
var InfoBanner = function (props) {
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('InfoBanner', props.className, props.colorCodedState && "state-" + props.colorCodedState, props.colorIntensity === 'intense' && 'intense', props.compact && 'compact'), style: props.color ? getContextColorStyle(Primary, props.color) : undefined },
            React.createElement("div", { className: "InfoBannerInner" },
                props.icon && React.createElement(BaseIcon, { className: "InfoBannerIcon", name: props.icon }),
                props.heading && (React.createElement("header", { className: "InfoBannerHeader" },
                    React.createElement("h4", { className: "InfoBannerHeading" }, renderRenderable(props.heading)))),
                (props.body || props.children) && (React.createElement("div", { className: "InfoBannerBody" },
                    renderRenderable(props.body),
                    props.children))))); } });
};
export default InfoBanner;
